import { Link } from 'react-router-dom'
import { LogOut } from 'lucide-react'
import { getNavItems, isNavItemActive } from './navigation'

type SidebarProps = {
  role: string | null
  pathname: string
  onLogout: () => void
}

export default function Sidebar({ role, pathname, onLogout }: SidebarProps) {
  const navItems = getNavItems(role)

  return (
    <aside className="app-sidebar" data-role={role ?? 'guest'}>
      <div className="app-sidebar__inner">
        <Link to="/landing" className="app-sidebar__brand" title="Перейти на лендинг">
          <img className="app-sidebar__brand-logo" src="/logolupa2.png" alt="ЛУПА" />
        </Link>
        <nav className="app-sidebar__nav" aria-label="Основная навигация">
          {navItems.map((item) => {
            const Icon = item.icon
            const active = isNavItemActive(pathname, item)

            return (
              <Link
                key={item.to}
                to={item.to}
                className={`app-sidebar__nav-item${active ? ' is-active' : ''}`}
                title={item.title}
                aria-current={active ? 'page' : undefined}
              >
                <span className="app-sidebar__nav-indicator" aria-hidden="true" />
                <Icon className="app-sidebar__nav-icon" />
                <span className="sr-only">{item.label}</span>
              </Link>
            )
          })}
        </nav>

        <button
          type="button"
          onClick={onLogout}
          className="app-sidebar__logout"
          title="Выйти"
          aria-label="Выйти"
        >
          <LogOut className="app-sidebar__logout-icon" />
        </button>
      </div>
    </aside>
  )
}
